$shm_projects_timeline $mol_view
	week? \
	sub /
		<= Timeline_head $mol_view
			sub /
				<= Timeline_title $mol_view
					sub / \Пререлизы
				<= Week_select $mol_select
					hint \Выберите неделю
					dictionary <= week_options *
					value? <=> week? \
					event *
						^
						pointerdown? <=> week_select_pointerdown? null
		<= Timeline_content $mol_view
			sub /
				<= Timeline_days $mol_view
					sub <= timeline_day_rows /$mol_view
				<= Week_summary $shm_projects_digest_view
					digest <= week_summary null
					refresh? <=> refresh_week? null
	Timeline_day* $mol_view
		attr *
			^
			today <= timeline_day_today* false
		sub /
			<= Timeline_day_title* $mol_view
				attr *
					^
					today <= timeline_day_today* false
				sub / <= timeline_day_title* \
			<= Timeline_events* $mol_view
				sub <= timeline_event_rows* /$mol_view
			^ day_summary_rows* /$mol_view
	Day_summary* $shm_projects_digest_day
		text <= day_summary* \
		refresh? <=> refresh_day*? null
	Timeline_event* $mol_link
		arg <= timeline_event_arg* *
		sub / <= timeline_event_title* \
	Timeline_empty* $mol_view
		sub / \—
